import styled from 'styled-components';

export const CertMain = styled.main`
  width: 80%;
  margin: 0 auto;
  padding: var(--space-xxl) 0;
  a {
    text-transform: lowercase;
    color: var(--grey6);
  }

  .cert-grid {
    display: grid;
    grid-template-columns: 1fr 320px;
    gap: 24px;
    align-items: start;
    max-width: 1100px;
    margin: 0 auto;
  }

  .cert-main {
    background: var(--white);
    padding: 18px;
    border-radius: 10px;
    border: 1px solid var(--grey15);
  }

  .cert-side {
    background: #fbfbfc;
    border: 1px solid var(--grey15);
    padding: 14px;
    border-radius: 10px;
    font-size: 14px;
  }

  .iframe-wrap {
    margin-top: 12px;
  }

  .cert-iframe {
    width: 100%;
    height: 70vh;
    border: 1px solid var(--grey25);
    border-radius: 8px;
  }

  .loading {
    display: flex;
    align-items: center;
  }

  .spinner {
    width: 18px;
    height: 18px;
    border-radius: 50%;
    border: 3px solid rgba(0, 0, 0, 0.06);
    border-top-color: var(--blue3);
    animation: spin 1s linear infinite;
  }

  .cert-error {
    color: var(--errorRed);
    margin-top: 12px;
  }

  .debug-url {
    margin-top: 6px;
    font-size: 12px;
    color: var(--grey4);
    word-break: break-all;
  }

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }

  @media (max-width: 900px) {
    width: 92%;
    .cert-grid {
      grid-template-columns: 1fr;
    }
    .cert-side {
      order: 2;
    }
    .cert-main {
      order: 1;
    }
  }
`;
